import { css, cx } from '@linaria/core';
import { flex, theming } from 'styles/utils';
export const tagWrapper = cx("omponents__Visibility__Visibility_styles_tsx-tagWrapper-t9aa339", flex.init, flex.alignItems.center);

require("./Visibility.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Visibility.styles.tsx");